import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import * as _ from 'lodash';
import {LogicalConjunctionService} from '../../../../services/common/logical-conjunction/logical-conjunction.service';

@Component({
  selector: 'routing-rule-dialog-destination',
  templateUrl: './routing-rule-dialog-destination.component.html',
  styleUrls: ['./routing-rule-dialog-destination.component.less']
})
export class RoutingRuleDialogDestinationComponent implements OnInit {

  @Input() destination: any;
  @Input() externalData: any;

  constructor(private logicalConjunctionService: LogicalConjunctionService) {}

  userGroups: any;
  prefixGroups: any;
  logicalConjunctionNotice: string;
  customers: any;

  ngOnInit(): void {
    this.initialize();
  }

  initialize(): void {
    this.userGroups = this.externalData.userGroups;
    this.prefixGroups = this.externalData.prefixGroups;
    this.customers = this.externalData.customers;
    this.updateLogicalConjunctionNotice();
  }

  updateLogicalConjunctionNotice(): void {
    const andItems = [];

    if (!_.isEmpty(this.destination.rrAttrs.prefix)) { andItems.push('Prefix'); }
    if (!_.isEmpty(this.destination.rrAttrs.host)) { andItems.push('Host'); }
    if (!_.isEmpty(this.destination.userGroups)) { andItems.push('User Group'); }
    if (!_.isEmpty(this.destination.destCustomers) || this.destination.allCustomers) { andItems.push('Customers'); }

    this.logicalConjunctionNotice = this.logicalConjunctionService.generateNoticeMessage(andItems, [], 'Destination');
  }
}
